import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ApplicationBase } from 'src/app/base/application-base';
import { PathHelper } from 'src/app/helpers/path.helper';
import { IWindowContent } from 'src/app/interfaces/os/window-content.interface';
import { VfmService } from 'src/app/services/io/vfm.service';
import { WindowsManagerService } from 'src/app/services/os/windows-manager.service';
import { ExplorerManager } from '../classes/explorer-manager';

@Component({
  selector: 'main-application',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent extends ApplicationBase implements IWindowContent, OnInit, OnDestroy {
  explorerManager = new ExplorerManager();

  windowId: number;
  private subscription: Subscription;

  constructor(
    private windowsSv: WindowsManagerService
  ) {
    super();
  }

  ngOnInit(): void {
    this.subscription = this.explorerManager.changeEvent.subscribe(() => {
      this.updateWindowTitle();
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  start(data: any, windowId: number) {
    this.windowId = windowId;

    let path = "";
    const { args = [] } = data || {};
    if (args.length > 1) {
      path = args[1];
      if (data.cwd) {
        path = PathHelper.join(data.cwd, path);
      }
    }

    this.explorerManager.cwd = path;

    if (this.windowsSv.getScreenSize().width > 1024) {
      this.windowsSv.resizeWindow(windowId, 1024, 400);
    }

    this.windowsSv.centerWindow(windowId);

    this.updateWindowTitle();
  }

  private updateWindowTitle() {
    const name = PathHelper.getName(this.explorerManager.cwd);
    if (name && name !== "") {
      this.windowsSv.setTitle(this.windowId, "Explorer - " + PathHelper.getName(this.explorerManager.cwd));
    }
    else {
      this.windowsSv.setTitle(this.windowId, "Explorer");
    }
  }
}
